import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex",
  "aria-label": "Breadcrumb"
}
const _hoisted_2 = {
  role: "list",
  class: "px-4 sm:px-6 lg:px-24 flex items-center space-x-4"
}
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "py-10 px-4 sm:px-6 lg:px-24" }
const _hoisted_6 = { class: "flex flex-col gap-8" }
const _hoisted_7 = { class: "flex flex-col md:flex-row md:items-center justify-between gap-4 mb-2 bg-white p-5 rounded-2xl border border-gray-100 shadow-sm" }
const _hoisted_8 = { class: "flex flex-wrap items-center gap-3" }
const _hoisted_9 = { class: "inline-flex rounded-xl bg-gray-50 p-1 border border-gray-200" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "relative min-w-[200px]" }
const _hoisted_12 = {
  key: 0,
  class: "bg-gradient-to-r from-emerald-800 to-teal-950 rounded-3xl p-6 text-white shadow-lg border border-teal-700/30 flex flex-col md:flex-row items-center justify-between gap-6 relative overflow-hidden"
}
const _hoisted_13 = { class: "flex-grow w-full md:w-auto" }
const _hoisted_14 = { class: "text-sm text-teal-100 font-semibold leading-relaxed max-w-2xl" }
const _hoisted_15 = { class: "text-white font-extrabold text-lg px-1.5 py-0.5 rounded bg-white/10" }
const _hoisted_16 = { class: "text-emerald-300 font-bold" }
const _hoisted_17 = { class: "font-extrabold" }
const _hoisted_18 = { class: "text-teal-300 font-bold" }
const _hoisted_19 = { class: "mt-5 w-full bg-teal-950/50 rounded-full h-3 border border-teal-800/30" }
const _hoisted_20 = { class: "flex justify-between items-center mt-2 text-xs font-semibold text-teal-300" }
const _hoisted_21 = { class: "flex-shrink-0 w-full md:w-auto text-right" }
const _hoisted_22 = {
  key: 0,
  disabled: "",
  class: "w-full md:w-auto px-6 py-3.5 bg-emerald-900/50 border border-emerald-700/50 text-emerald-300/80 font-extrabold text-sm rounded-xl cursor-not-allowed uppercase tracking-wider"
}
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_25 = { key: 1 }
const _hoisted_26 = {
  key: 2,
  disabled: "",
  class: "w-full md:w-auto px-6 py-3.5 bg-white/20 text-white/50 border border-white/10 font-extrabold text-sm rounded-xl cursor-not-allowed uppercase tracking-wider"
}
const _hoisted_27 = { class: "grid grid-cols-1 gap-5 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5" }
const _hoisted_28 = { class: "group relative overflow-hidden rounded-2xl bg-white p-5 border border-gray-100 shadow-sm hover:shadow-md hover:border-indigo-100 hover:scale-[1.01] transition-all duration-300" }
const _hoisted_29 = { class: "flex items-center gap-4" }
const _hoisted_30 = { class: "text-xs font-bold text-gray-400 uppercase tracking-wider" }
const _hoisted_31 = { class: "text-3xl font-black text-gray-900 mt-1" }
const _hoisted_32 = { class: "group relative overflow-hidden rounded-2xl bg-white p-5 border border-gray-100 shadow-sm hover:shadow-md hover:border-emerald-100 hover:scale-[1.01] transition-all duration-300" }
const _hoisted_33 = { class: "flex items-center gap-4" }
const _hoisted_34 = { class: "text-xs font-bold text-gray-400 uppercase tracking-wider" }
const _hoisted_35 = { class: "text-3xl font-black text-gray-900 mt-1" }
const _hoisted_36 = { class: "group relative overflow-hidden rounded-2xl bg-white p-5 border border-gray-100 shadow-sm hover:shadow-md hover:border-amber-100 hover:scale-[1.01] transition-all duration-300" }
const _hoisted_37 = { class: "flex items-center gap-4" }
const _hoisted_38 = { class: "text-xs font-bold text-gray-400 uppercase tracking-wider" }
const _hoisted_39 = { class: "text-3xl font-black text-gray-900 mt-1" }
const _hoisted_40 = {
  key: 0,
  class: "group relative overflow-hidden rounded-2xl bg-white p-5 border border-gray-100 shadow-sm hover:shadow-md hover:border-purple-100 hover:scale-[1.01] transition-all duration-300"
}
const _hoisted_41 = { class: "flex items-center gap-4" }
const _hoisted_42 = { class: "text-xs font-bold text-gray-400 uppercase tracking-wider" }
const _hoisted_43 = { class: "text-3xl font-black text-gray-900 mt-1" }
const _hoisted_44 = { class: "group relative overflow-hidden rounded-2xl bg-white p-5 border border-gray-100 shadow-sm hover:shadow-md hover:border-rose-100 hover:scale-[1.01] transition-all duration-300" }
const _hoisted_45 = { class: "flex items-center gap-4" }
const _hoisted_46 = { class: "text-xs font-bold text-gray-400 uppercase tracking-wider" }
const _hoisted_47 = { class: "text-3xl font-black text-gray-900 mt-1" }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { class: "grid grid-cols-1 gap-5 md:grid-cols-2" }
const _hoisted_50 = { class: "group relative overflow-hidden rounded-2xl bg-white p-6 border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300" }
const _hoisted_51 = { class: "flex items-center justify-between" }
const _hoisted_52 = { class: "text-xs font-bold text-gray-400 uppercase tracking-wider" }
const _hoisted_53 = { class: "text-3xl font-black text-theme-active mt-2" }
const _hoisted_54 = { class: "group relative overflow-hidden rounded-2xl bg-white p-6 border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300" }
const _hoisted_55 = { class: "flex items-center justify-between" }
const _hoisted_56 = { class: "text-xs font-bold text-gray-400 uppercase tracking-wider" }
const _hoisted_57 = { class: "text-3xl font-black text-theme-active mt-2" }
const _hoisted_58 = {
  key: 2,
  class: "grid grid-cols-1 lg:grid-cols-2 gap-8 mt-4"
}
const _hoisted_59 = { class: "bg-white rounded-2xl border border-gray-100 p-5 shadow-sm" }
const _hoisted_60 = { class: "flex items-center justify-between mb-6" }
const _hoisted_61 = {
  key: 0,
  class: "h-[300px] flex items-center justify-center"
}
const _hoisted_62 = { class: "bg-white rounded-2xl border border-gray-100 p-5 shadow-sm" }
const _hoisted_63 = { class: "flex items-center justify-between mb-6" }
const _hoisted_64 = {
  key: 0,
  class: "h-[300px] flex items-center justify-center"
}
const _hoisted_65 = { class: "w-full max-w-md mx-auto bg-white rounded-3xl p-6 md:p-8 shadow-[0_12px_40px_rgba(0,0,0,0.12)] border border-slate-100 flex flex-col relative" }
const _hoisted_66 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-6 text-center"
}
const _hoisted_67 = { class: "mt-2 text-sm text-gray-500 leading-relaxed max-w-xs font-regular" }
const _hoisted_68 = { class: "block mt-1 font-bold text-rose-600 tracking-wide" }
const _hoisted_69 = {
  key: 1,
  class: "flex flex-col gap-6"
}
const _hoisted_70 = { class: "bg-gray-50 rounded-2xl p-5 border border-gray-200/60 flex flex-col gap-3 text-left" }
const _hoisted_71 = { class: "flex justify-between border-b border-gray-200/40 pb-2" }
const _hoisted_72 = { class: "text-sm font-bold text-gray-800" }
const _hoisted_73 = { class: "flex justify-between border-b border-gray-200/40 pb-2" }
const _hoisted_74 = { class: "text-sm font-bold text-gray-800" }
const _hoisted_75 = { class: "flex justify-between border-b border-gray-200/40 pb-2" }
const _hoisted_76 = { class: "text-sm font-bold text-gray-800" }
const _hoisted_77 = { class: "flex justify-between pb-1" }
const _hoisted_78 = { class: "text-sm font-bold text-gray-800" }
const _hoisted_79 = { class: "flex flex-col gap-2 text-left" }
const _hoisted_80 = { class: "relative rounded-xl border border-gray-200 flex items-center bg-gray-50 focus-within:bg-white focus-within:border-theme-active transition-all duration-200" }
const _hoisted_81 = ["max"]
const _hoisted_82 = { class: "pr-4 text-xs font-bold text-emerald-600 whitespace-nowrap" }
const _hoisted_83 = {
  key: 0,
  class: "text-xs text-rose-600 font-semibold mt-1"
}
const _hoisted_84 = { class: "text-[11px] text-gray-400 mt-1 font-medium" }
const _hoisted_85 = { class: "text-gray-700 font-bold" }
const _hoisted_86 = { class: "flex items-center justify-end gap-3 mt-4" }
const _hoisted_87 = ["disabled"]
const _hoisted_88 = {
  key: 0,
  class: "animate-spin h-3.5 w-3.5 text-white",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_89 = {
  key: 0,
  class: "text-ef-error mt-2 text-left"
}

import { computed, ref, watch, onMounted } from 'vue'
import { BarChart } from 'vue-chart-3'
import { Chart, registerables } from "chart.js"
import ListBox from '@/widgets/ListBox.vue'
import { logout, isLoggedIn, handleApiError, disableScroll, enableScroll } from '@/utils/common'
import Dashboard from '@/composables/admin/Dashboard'
import Loader from '@/widgets/Loader.vue'
import router from '@/router'
import 'flatpickr/dist/flatpickr.css'
import Modal from '@/widgets/Modal.vue'
import flatPickr from 'vue-flatpickr-component'
import { NotificationType } from '@/types/index'
import Agent from '@/composables/admin/agent'
import { LOADER_MINIMUM_TIME } from '@/utils/constants'

type ChartOption = 'daily' | 'monthly' | 'weekly'

export default /*@__PURE__*/_defineComponent({
  __name: 'dashboard',
  props: ['user', 'agent', 'breadcrump'],
  setup(__props) {

const pages = [
  { name: 'Projects', href: '#', current: false },
  { name: 'Project Nero', href: '#', current: true },
]
const props = __props
Chart.register(...registerables)
const bookingsData = ref<any>(null)
const salesData = ref<any>(null)
const isLoading = ref<boolean>(true)
const timeElapsed = ref<number>(0)
const { fetchData }  = Dashboard()
const dates = ref<string | null>(null)
const subAgent = ref<any>(props.agent ? props.agent : '')
const auth = isLoggedIn()
// const loyaltyData = ref<any>()
const loyaltyData = ref<any>({
  points_earned: 0,
  total_points: 0,
  has_redeemed: 0
})
const openModal = ref<boolean>(false)
const isBusy = ref<boolean>(false)
const notif = ref<NotificationType>({ show: false, type: 'success', message: '', messageDetails: ''})
const { requestRedeemLoyalty, agentProfile } = Agent()
const loyaltyRedeemForm = ref<any>({
   bankName: { value: '', error: false, errorMessage: '' },
   accountName: { value: '', error: false, errorMessage: '' },
   accountNumber: { value: '', error: false, errorMessage: '' },
   countryName: { value: '', error: false, errorMessage: '' }
})

const dateRangeConfig : any = {
   mode: 'range',
   altFormat: 'd-m-Y',
   altInput: true,
   dateFormat: 'd-m-Y'
}

onMounted(async () => {

   disableScroll()
   const startTime = performance.now()
   await fetchAllData()
   timeElapsed.value = performance.now() - startTime
   if (timeElapsed.value < LOADER_MINIMUM_TIME) {
      const diff = LOADER_MINIMUM_TIME - timeElapsed.value
      setTimeout(() => {
         enableScroll()
         isLoading.value = false
      }, diff)
   } else {
      enableScroll()
      isLoading.value = false
   }
})

const agentProfileDetails = ref<any>(null)
const pointsToWithdraw = ref<number | null>(null)
const pointsError = ref<string>('')
const isProfileLoading = ref<boolean>(false)

const missingBankFields = computed(() => {
   const missing = []
   if (!agentProfileDetails.value) return ['Bank Name', 'Account Title', 'Account Number/IBAN', 'Country']
   if (!agentProfileDetails.value.bank_name) missing.push('Bank Name')
   if (!agentProfileDetails.value.bank_account_name) missing.push('Account Title')
   if (!agentProfileDetails.value.bank_account_number) missing.push('Account Number or IBAN')
   if (!agentProfileDetails.value.country) missing.push('Country')
   return missing
})

const handleRedeemPoints = async () => {
   isProfileLoading.value = true
   const profileRes = await agentProfile()
   isProfileLoading.value = false
   if (profileRes.status === 200) {
      agentProfileDetails.value = profileRes.data.data
      
      loyaltyRedeemForm.value.bankName.value = profileRes.data.data.bank_name || ''
      loyaltyRedeemForm.value.accountName.value = profileRes.data.data.bank_account_name || ''
      loyaltyRedeemForm.value.accountNumber.value = profileRes.data.data.bank_account_number || ''
      loyaltyRedeemForm.value.countryName.value = profileRes.data.data.country || ''
      
      pointsToWithdraw.value = loyaltyData.value ? Math.floor(Number(loyaltyData.value.points_earned)) : 0
   }
   openModal.value = true
}

const handleModalClose = () => openModal.value = false

const scopes = ref<any>(
   [
      {id: 'today', name: 'Today', isCurrent: false},
      {id: 'yesterday', name: 'Yesterday', isCurrent: false},
      {id: 'last_7_days', name: 'Last 7 Days', isCurrent: false},
      {id: 'this_month', name: 'This Month', isCurrent: true},
      {id: 'last_month', name: 'Last Month', isCurrent: false},
      {id: 'all_time', name: 'All Time', isCurrent: false},
      {id: 'custom', name: 'Custom Duration', isCurrent: false}
   ]
)

const nonCustomScopes = computed(() => scopes.value.filter((s: any) => !s.id.includes('custom')))
const isCustomScopeCurrent = computed(() => scopes.value.find((s: any) => s.id.includes('custom'))?.isCurrent)

const validateForm = () : boolean => {
   pointsError.value = ''
   let response = true
   
   if (!pointsToWithdraw.value || pointsToWithdraw.value <= 0) {
      pointsError.value = 'Please enter a valid points amount'
      response = false
   } else if (loyaltyData.value && pointsToWithdraw.value > Number(loyaltyData.value.points_earned)) {
      pointsError.value = 'Cannot exceed your accumulated points'
      response = false
   }
   
   return response
}

const handleModalSubmit = async () => {

   const isValid = validateForm()

   if (isValid && !isBusy.value && auth && auth.user) {
      isBusy.value = true
      const response = await requestRedeemLoyalty(loyaltyRedeemForm.value, pointsToWithdraw.value || 0)
      isBusy.value = false

      if (response.status == 200) {
         openModal.value = false
         await fetchAllData()
      } else {
         loyaltyRedeemForm.value.error = handleApiError(response)
      }
   }
}

const dataOptions = [
   { title: 'Daily', description: '', value: 'daily', current: true },
   { title: 'Weekly', description: '', value: 'weekly', current: false },
   { title: 'Monthly', description: '', value: 'monthly', current: false },
]

const bookingStats = ref<any>({
      total: { id: 1, name: 'Confirmed / Total Bookings', stat: 0 },
      confirmed: { id: 2, name: 'Paid', stat: 0 },
      pending: { id: 3, name: 'Unpaid', stat: 0 },
      subAgents: { id: 4, name: 'Online Bookings', stat: 0 },
      cancelled: { id: 5, name: 'Cancelled Bookings', stat: 0 }
})

const notifClosed = () : void => {
   notif.value.show = false
}

const salesStats = ref<any>(
   {
      total: { id: 1, name: 'Total Sales', stat: 0 },
      commission: { id: 2, name: 'Total Commission', stat: 0 },
      pending: { id: 3, name: 'Pending Payments', stat: 0 },
      average: { id: 4, name: 'Avg Booking Value', stat: 0 }
   }
)

const handleSelectedOption = async (name: string, value: ChartOption) => {

   await fetchChartData(name, value) 
}

const redirectBookings = (status = '') => {
   const query = status ? { status } : {}
   if (props.user.type == 'admin') {
      router.push({name: 'AdminBookings', query})
   } else if (props.user.type == 'agent') {
      router.push({name: 'UserBookings', params: {userType: 'agent', subUserId: ''}, query})
   } else if (props.user.type == 'corporate') {
      router.push({name: 'UserBookings', params: {userType: 'corporate', subUserId: ''}, query})
   } else if (props.user.type == 'web') {
      router.push({name: 'UserBookings', params: {userType: 'web', subUserId: ''}, query})
   }
}

const fetchChartData = async (chartName: string, option: ChartOption) => {

   const response = await fetchData(chartName, option, subAgent.value)

   if (response.status == 200) {
      
      if (chartName == 'bookings_chart') {

         prepareChartData('bookings', response)
      } else if (chartName == 'sales_chart') {
         
         prepareChartData('sales', response)
      }
   }
}

const fetchAllData = async () => {
  const activeScope = scopes.value.find((scope: any) => scope.isCurrent)
  const scopeId = activeScope ? activeScope.id : 'this_month'
  const response = await fetchData('all', scopeId, subAgent.value)

  if (response.status == 200) {
    prepareChartData('bookings', response)
    prepareChartData('sales', response)
    prepareBookingStats(response)
    prepareSalesStats(response)

    // ✅ safe read (if backend omits the node, keep the default)
    loyaltyData.value = response.data?.loyalty_summary ?? loyaltyData.value
  } else if (response.response && response.response.status == 401) {
    logout(router)
  } else {
    // ✅ non-200 and not 401: keep the default object
    loyaltyData.value = loyaltyData.value
  }
}

const fetchStats = async () => {

   const activeScope = scopes.value.find((scope: any) => scope.isCurrent)

   if (activeScope) {

      const response = await fetchData('stats', activeScope.id, subAgent.value)
      if (response.status == 200) {
         
         prepareBookingStats(response)
         prepareSalesStats(response)
      }
   }
}

const prepareChartData = (chartName: string, response: any) => {

   if (chartName == 'bookings') {

      bookingsData.value = {
         labels: response.data.bookings_chart.data.labels,
         datasets: [
            {
               label: 'Bookings',
               data: response.data.bookings_chart.data.sets,
               backgroundColor: ['#77CEFF', '#0079AF', '#123E6B', '#97B0C4', '#A5C8ED', '#77CEFF','#77CEFF','#77CEFF','#77CEFF'],
            },
         ]
      }
   } else if (chartName == 'sales') {

      salesData.value = {
         labels: response.data.sales_chart.data.labels,
         datasets: [
            {
               label: 'Sales',
               data: response.data.sales_chart.data.sets,
               backgroundColor: ['#f87979', '#f87979', '#f87979', '#f87979', '#f87979', '#f87979','#f87979','#f87979','#f87979'],
            },
         ]
      }
   }
}

const prepareBookingStats = (response: any) => {

   bookingStats.value.total.stat = response.data.bookings_summary.total_bookings
   bookingStats.value.confirmed.stat = response.data.bookings_summary.confirmed_bookings
   bookingStats.value.pending.stat = response.data.bookings_summary.pending_bookings
   bookingStats.value.subAgents.stat = response.data.bookings_summary.sub_agent_bookings
   bookingStats.value.cancelled.stat = response.data.bookings_summary.cancelled_bookings
}

const prepareSalesStats = (response: any) => {

   salesStats.value.total.stat = response.data.sales_summary.total_sales
   salesStats.value.commission.stat = response.data.sales_summary.commission
   salesStats.value.pending.stat = response.data.sales_summary.pending_sales
   salesStats.value.average.stat = response.data.sales_summary.average
}

const handleScopeUpdate = async (item: any) => {

   scopes.value.forEach((scope: any) => {
      scope.isCurrent = false
   })

   scopes.value.find((scope: any) => scope.id === item.id).isCurrent = true
   dates.value = ''

   await fetchStats()
}

watch(() => props.agent, (newVallue, oldValue) => {
   
   subAgent.value = newVallue
   refetchData()
})

const refetchData = async () => {
   await fetchAllData()
}

watch(dates, (newValue, oldValue) => {

   if (newValue?.includes('to')) {
      
      scopes.value.forEach((scope: any) => {
         if (!scope.id.includes('custom')) {
            scope.isCurrent = false
         } else {
            scope.isCurrent = true
            const dateRange = `${newValue.split(' to ')[0]}_${newValue.split(' to ')[1]}`
            scope.id = `custom_${dateRange}`
         }
      })

      fetchStats().then(() => {
         
      })
   }
})


return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.breadcrump)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
          _createElementVNode("ol", _hoisted_2, [
            _createElementVNode("li", null, [
              _createElementVNode("div", null, [
                _createElementVNode("div", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({name: 'Home'}))),
                  class: "text-gray-400 :hover:text-gray-500 cursor-pointer"
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    size: "lg",
                    icon: "fa-solid fa-home",
                    class: "text-gray-500"
                  }),
                  _cache[8] || (_cache[8] = _createElementVNode("span", { class: "sr-only" }, "Home", -1))
                ])
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.breadcrump, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.title
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _cache[9] || (_cache[9] = _createElementVNode("svg", {
                    class: "h-5 w-5 flex-shrink-0 text-gray-300",
                    fill: "currentColor",
                    viewBox: "0 0 20 20",
                    "aria-hidden": "true"
                  }, [
                    _createElementVNode("path", { d: "M5.555 17.776l8-16 .894.448-8 16-.894-.448z" })
                  ], -1)),
                  _createElementVNode("div", {
                    onClick: ($event: any) => (item.link ? _unref(router).push(item.link) : null),
                    class: _normalizeClass([item.link ? 'cursor-pointer hover:text-gray-500' : '', "ml-4 text-sm font-medium text-gray-500"])
                  }, _toDisplayString(item.title), 11, _hoisted_4)
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("main", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[11] || (_cache[11] = _createElementVNode("div", null, [
            _createElementVNode("h1", { class: "text-xl font-bold text-gray-900" }, "Dashboard Overview"),
            _createElementVNode("p", { class: "text-xs font-semibold text-gray-500 mt-1" }, "Real-time performance metrics and bookings overview")
          ], -1)),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nonCustomScopes.value, (item) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: item.id,
                  onClick: ($event: any) => (handleScopeUpdate(item)),
                  class: _normalizeClass([item.isCurrent ? 'bg-white text-theme-active shadow-sm font-bold' : 'text-gray-600 hover:text-gray-900 font-semibold', "px-3.5 py-1.5 text-xs rounded-lg transition-all duration-200"])
                }, _toDisplayString(item.name), 11, _hoisted_10))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400" }, [
                _createElementVNode("i", { class: "pi pi-calendar text-xs" })
              ], -1)),
              _createVNode(_unref(flatPickr), {
                modelValue: dates.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dates).value = $event)),
                config: dateRangeConfig,
                class: _normalizeClass([isCustomScopeCurrent.value ? 'border-theme-active ring-2 ring-theme-active/10 text-theme-active font-bold' : 'border-gray-200 text-gray-700', "pl-8 pr-4 py-2 border rounded-xl text-xs w-full bg-white focus:outline-none focus:ring-2 focus:ring-theme-active focus:border-transparent transition-all duration-200"]),
                placeholder: "Custom date range..."
              }, null, 8, ["modelValue", "class"])
            ])
          ])
        ]),
        (_unref(auth) && _unref(auth).user && _unref(auth).user.type == 'agent' && _unref(auth).user.sub_type == null && loyaltyData.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _cache[21] || (_cache[21] = _createElementVNode("div", { class: "absolute -right-16 -top-16 w-48 h-48 bg-teal-500/10 rounded-full blur-3xl pointer-events-none" }, null, -1)),
              _cache[22] || (_cache[22] = _createElementVNode("div", { class: "absolute -left-16 -bottom-16 w-48 h-48 bg-emerald-500/10 rounded-full blur-3xl pointer-events-none" }, null, -1)),
              _createElementVNode("div", _hoisted_13, [
                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "flex items-center gap-2 mb-1" }, [
                  _createElementVNode("i", { class: "pi pi-gift text-xl text-emerald-400" }),
                  _createElementVNode("h3", { class: "text-lg font-extrabold tracking-wide uppercase" }, "Loyalty Program Reward")
                ], -1)),
                _cache[19] || (_cache[19] = _createElementVNode("p", { class: "text-xs text-emerald-300 font-semibold mb-3" }, " * Loyalty Program will be calculated from 01-07-2026 ", -1)),
                _createElementVNode("p", _hoisted_14, [
                  _cache[12] || (_cache[12] = _createTextVNode(" You have accumulated ")),
                  _createElementVNode("span", _hoisted_15, _toDisplayString(loyaltyData.value.points_earned), 1),
                  _cache[13] || (_cache[13] = _createTextVNode(" points (")),
                  _createElementVNode("span", _hoisted_16, "$" + _toDisplayString((Number(loyaltyData.value.points_earned) * (Number(loyaltyData.value.redeem_rate) || 0.1)).toFixed(2)) + " USD", 1),
                  _cache[14] || (_cache[14] = _createTextVNode("). Reach the target of ")),
                  _createElementVNode("span", _hoisted_17, _toDisplayString(loyaltyData.value.total_points), 1),
                  _cache[15] || (_cache[15] = _createTextVNode(" points (")),
                  _createElementVNode("span", _hoisted_18, "$" + _toDisplayString((Number(loyaltyData.value.total_points) * (Number(loyaltyData.value.redeem_rate) || 0.1)).toFixed(2)) + " USD", 1),
                  _cache[16] || (_cache[16] = _createTextVNode(") to request a withdrawal! "))
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", {
                    class: "bg-gradient-to-r from-emerald-400 to-teal-300 h-full rounded-full transition-all duration-500 shadow-[0_0_8px_rgba(52,211,153,0.5)]",
                    style: _normalizeStyle({ width: `${Math.min(100, ((Number(loyaltyData.value.points_earned) || 0) / Math.max(1, Number(loyaltyData.value.total_points) || 1)) * 100)}%` })
                  }, null, 4)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _cache[17] || (_cache[17] = _createElementVNode("span", null, "0 Points", -1)),
                  _createElementVNode("span", null, _toDisplayString(Math.min(100, Math.round(((Number(loyaltyData.value.points_earned) || 0) / Math.max(1, Number(loyaltyData.value.total_points) || 1)) * 100))) + "% Completed", 1),
                  _createElementVNode("span", null, _toDisplayString(loyaltyData.value.total_points) + " Points Target", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                (loyaltyData.value.pending_withdraw)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_22, " Withdrawal Processing "))
                  : (Number(loyaltyData.value.points_earned) >= Number(loyaltyData.value.total_points))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: handleRedeemPoints,
                        disabled: isProfileLoading.value,
                        class: "w-full md:w-auto px-6 py-3.5 bg-white text-emerald-900 hover:bg-emerald-50 active:scale-[0.98] transition-all duration-200 font-extrabold text-sm rounded-xl shadow-md uppercase tracking-wider min-w-[160px] text-center flex items-center justify-center"
                      }, [
                        (isProfileLoading.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, _cache[20] || (_cache[20] = [
                              _createElementVNode("svg", {
                                class: "animate-spin h-4 w-4 text-emerald-900",
                                fill: "none",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("circle", {
                                  class: "opacity-25",
                                  cx: "12",
                                  cy: "12",
                                  r: "10",
                                  stroke: "currentColor",
                                  "stroke-width": "4"
                                }),
                                _createElementVNode("path", {
                                  class: "opacity-75",
                                  fill: "currentColor",
                                  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                })
                              ], -1),
                              _createTextVNode(" Loading... ")
                            ])))
                          : (_openBlock(), _createElementBlock("span", _hoisted_25, "Withdraw Now"))
                      ], 8, _hoisted_23))
                    : (_openBlock(), _createElementBlock("button", _hoisted_26, " Withdraw Now "))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _cache[33] || (_cache[33] = _createElementVNode("div", { class: "mb-4" }, [
            _createElementVNode("h3", { class: "text-base font-bold text-gray-900" }, "Reservations Summary"),
            _createElementVNode("p", { class: "text-xs font-semibold text-gray-500 mt-0.5" }, "Quick lookup of your booking status counts")
          ], -1)),
          _createElementVNode("dl", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _cache[23] || (_cache[23] = _createElementVNode("div", { class: "rounded-xl bg-indigo-50 text-indigo-600 p-3.5 group-hover:scale-110 transition-all duration-300" }, [
                  _createElementVNode("i", { class: "pi pi-calendar text-lg font-bold" })
                ], -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_30, _toDisplayString(bookingStats.value.total.name), 1),
                  _createElementVNode("p", _hoisted_31, _toDisplayString(bookingStats.value.total.stat), 1)
                ])
              ]),
              _createElementVNode("div", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (redirectBookings())),
                class: "cursor-pointer border-t border-gray-50 mt-4 pt-3 flex items-center justify-between text-xs font-bold text-indigo-600 group-hover:text-indigo-700 transition-colors"
              }, _cache[24] || (_cache[24] = [
                _createElementVNode("span", null, "View Details", -1),
                _createElementVNode("i", { class: "pi pi-arrow-right text-[10px]" }, null, -1)
              ]))
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _cache[25] || (_cache[25] = _createElementVNode("div", { class: "rounded-xl bg-emerald-50 text-emerald-600 p-3.5 group-hover:scale-110 transition-all duration-300" }, [
                  _createElementVNode("i", { class: "pi pi-check-circle text-lg font-bold" })
                ], -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_34, _toDisplayString(bookingStats.value.confirmed.name), 1),
                  _createElementVNode("p", _hoisted_35, _toDisplayString(bookingStats.value.confirmed.stat), 1)
                ])
              ]),
              _createElementVNode("div", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (redirectBookings('confirmed'))),
                class: "cursor-pointer border-t border-gray-50 mt-4 pt-3 flex items-center justify-between text-xs font-bold text-emerald-600 group-hover:text-emerald-700 transition-colors"
              }, _cache[26] || (_cache[26] = [
                _createElementVNode("span", null, "View Details", -1),
                _createElementVNode("i", { class: "pi pi-arrow-right text-[10px]" }, null, -1)
              ]))
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _cache[27] || (_cache[27] = _createElementVNode("div", { class: "rounded-xl bg-amber-50 text-amber-600 p-3.5 group-hover:scale-110 transition-all duration-300" }, [
                  _createElementVNode("i", { class: "pi pi-clock text-lg font-bold" })
                ], -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_38, _toDisplayString(bookingStats.value.pending.name), 1),
                  _createElementVNode("p", _hoisted_39, _toDisplayString(bookingStats.value.pending.stat), 1)
                ])
              ]),
              _createElementVNode("div", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (redirectBookings('awaiting_payment'))),
                class: "cursor-pointer border-t border-gray-50 mt-4 pt-3 flex items-center justify-between text-xs font-bold text-amber-600 group-hover:text-amber-700 transition-colors"
              }, _cache[28] || (_cache[28] = [
                _createElementVNode("span", null, "View Details", -1),
                _createElementVNode("i", { class: "pi pi-arrow-right text-[10px]" }, null, -1)
              ]))
            ]),
            (__props.user.type == 'agent' && __props.user.sub_type == null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _cache[29] || (_cache[29] = _createElementVNode("div", { class: "rounded-xl bg-purple-50 text-purple-600 p-3.5 group-hover:scale-110 transition-all duration-300" }, [
                      _createElementVNode("i", { class: "pi pi-users text-lg font-bold" })
                    ], -1)),
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_42, _toDisplayString(bookingStats.value.subAgents.name), 1),
                      _createElementVNode("p", _hoisted_43, _toDisplayString(bookingStats.value.subAgents.stat), 1)
                    ])
                  ]),
                  _createElementVNode("div", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (redirectBookings())),
                    class: "cursor-pointer border-t border-gray-50 mt-4 pt-3 flex items-center justify-between text-xs font-bold text-purple-600 group-hover:text-purple-700 transition-colors"
                  }, _cache[30] || (_cache[30] = [
                    _createElementVNode("span", null, "View Details", -1),
                    _createElementVNode("i", { class: "pi pi-arrow-right text-[10px]" }, null, -1)
                  ]))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _cache[31] || (_cache[31] = _createElementVNode("div", { class: "rounded-xl bg-rose-50 text-rose-600 p-3.5 group-hover:scale-110 transition-all duration-300" }, [
                  _createElementVNode("i", { class: "pi pi-times-circle text-lg font-bold" })
                ], -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_46, _toDisplayString(bookingStats.value.cancelled.name), 1),
                  _createElementVNode("p", _hoisted_47, _toDisplayString(bookingStats.value.cancelled.stat), 1)
                ])
              ]),
              _createElementVNode("div", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (redirectBookings('cancelled'))),
                class: "cursor-pointer border-t border-gray-50 mt-4 pt-3 flex items-center justify-between text-xs font-bold text-rose-600 group-hover:text-rose-700 transition-colors"
              }, _cache[32] || (_cache[32] = [
                _createElementVNode("span", null, "View Details", -1),
                _createElementVNode("i", { class: "pi pi-arrow-right text-[10px]" }, null, -1)
              ]))
            ])
          ])
        ]),
        (__props.user.type !== 'web')
          ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
              _cache[38] || (_cache[38] = _createElementVNode("div", { class: "mb-4" }, [
                _createElementVNode("h3", { class: "text-base font-bold text-gray-900" }, "Financial Summary"),
                _createElementVNode("p", { class: "text-xs font-semibold text-gray-500 mt-0.5" }, "Summary of total revenue and booking values")
              ], -1)),
              _createElementVNode("dl", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_52, _toDisplayString(salesStats.value.total.name), 1),
                      _createElementVNode("p", _hoisted_53, "$" + _toDisplayString(salesStats.value.total.stat), 1)
                    ]),
                    _cache[34] || (_cache[34] = _createElementVNode("div", { class: "rounded-2xl bg-emerald-50 text-theme-active p-4 group-hover:scale-110 transition-all duration-300" }, [
                      _createElementVNode("i", { class: "pi pi-wallet text-xl" })
                    ], -1))
                  ]),
                  _cache[35] || (_cache[35] = _createElementVNode("div", { class: "mt-4 text-xs font-semibold text-gray-400 flex items-center gap-1" }, [
                    _createElementVNode("i", { class: "pi pi-info-circle text-[10px]" }),
                    _createElementVNode("span", null, "Includes completed and pending collection orders")
                  ], -1))
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_56, _toDisplayString(salesStats.value.average.name), 1),
                      _createElementVNode("p", _hoisted_57, "$" + _toDisplayString(salesStats.value.average.stat), 1)
                    ]),
                    _cache[36] || (_cache[36] = _createElementVNode("div", { class: "rounded-2xl bg-indigo-50 text-indigo-600 p-4 group-hover:scale-110 transition-all duration-300" }, [
                      _createElementVNode("i", { class: "pi pi-percentage text-xl" })
                    ], -1))
                  ]),
                  _cache[37] || (_cache[37] = _createElementVNode("div", { class: "mt-4 text-xs font-semibold text-gray-400 flex items-center gap-1" }, [
                    _createElementVNode("i", { class: "pi pi-info-circle text-[10px]" }),
                    _createElementVNode("span", null, "Average value generated per reservation")
                  ], -1))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (__props.user.type !== 'web')
          ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _cache[39] || (_cache[39] = _createElementVNode("div", null, [
                    _createElementVNode("h3", { class: "text-base font-bold text-gray-950" }, "Bookings Growth"),
                    _createElementVNode("p", { class: "text-xs font-semibold text-gray-400 mt-0.5" }, "Reservations volume over time")
                  ], -1)),
                  _createElementVNode("div", null, [
                    _createVNode(ListBox, {
                      name: "bookings_chart",
                      data: dataOptions,
                      onSelected: handleSelectedOption
                    })
                  ])
                ]),
                (bookingsData.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                      _createVNode(_unref(BarChart), {
                        chartData: bookingsData.value,
                        options: { responsive: true, maintainAspectRatio: false }
                      }, null, 8, ["chartData"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, [
                  _cache[40] || (_cache[40] = _createElementVNode("div", null, [
                    _createElementVNode("h3", { class: "text-base font-bold text-gray-950" }, "Sales Growth"),
                    _createElementVNode("p", { class: "text-xs font-semibold text-gray-400 mt-0.5" }, "Revenue generation over time")
                  ], -1)),
                  _createElementVNode("div", null, [
                    _createVNode(ListBox, {
                      name: "sales_chart",
                      data: dataOptions,
                      onSelected: handleSelectedOption
                    })
                  ])
                ]),
                (salesData.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                      _createVNode(_unref(BarChart), {
                        chartData: salesData.value,
                        options: { responsive: true, maintainAspectRatio: false }
                      }, null, 8, ["chartData"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(Modal, {
      show: openModal.value,
      canClose: true,
      onClosed: handleModalClose
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_65, [
          _createElementVNode("div", { class: "flex items-center justify-between mb-6 pb-4 border-b border-gray-100" }, [
            _cache[42] || (_cache[42] = _createElementVNode("div", { class: "text-left" }, [
              _createElementVNode("h2", { class: "text-lg font-bold text-gray-900 tracking-tight" }, "Request Loyalty Points Payout"),
              _createElementVNode("p", { class: "text-xs text-gray-500 font-medium mt-1" }, "Review bank details and confirm cashout points.")
            ], -1)),
            _createElementVNode("button", {
              onClick: handleModalClose,
              class: "text-gray-400 hover:text-gray-600 transition-colors p-1.5 hover:bg-gray-50 rounded-lg"
            }, _cache[41] || (_cache[41] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                "stroke-width": "2",
                stroke: "currentColor",
                class: "w-5 h-5"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M6 18L18 6M6 6l12 12"
                })
              ], -1)
            ]))
          ]),
          (!agentProfileDetails.value || !agentProfileDetails.value.bank_name || !agentProfileDetails.value.bank_account_name || !agentProfileDetails.value.bank_account_number || !agentProfileDetails.value.country)
            ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                _cache[45] || (_cache[45] = _createElementVNode("div", { class: "h-16 w-16 bg-rose-50 rounded-full flex items-center justify-center text-rose-500 mb-4 ring-8 ring-rose-50/50" }, [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    "stroke-width": "2",
                    stroke: "currentColor",
                    class: "w-8 h-8"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                    })
                  ])
                ], -1)),
                _cache[46] || (_cache[46] = _createElementVNode("h3", { class: "text-base font-bold text-gray-900" }, "Missing Bank Details", -1)),
                _createElementVNode("p", _hoisted_67, [
                  _cache[43] || (_cache[43] = _createTextVNode(" Kindly fill the missing bank details in your profile first: ")),
                  _createElementVNode("span", _hoisted_68, _toDisplayString(missingBankFields.value.join(', ')), 1)
                ]),
                _createVNode(_component_router_link, {
                  to: "/agent/settings",
                  class: "mt-6 px-5 py-3 bg-theme-active hover:bg-theme-active/95 text-white font-extrabold text-xs uppercase tracking-wider rounded-xl transition-all shadow-md active:scale-95 text-center"
                }, {
                  default: _withCtx(() => _cache[44] || (_cache[44] = [
                    _createTextVNode(" Go to Profile Settings ")
                  ])),
                  _: 1
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, [
                  _createElementVNode("div", _hoisted_71, [
                    _cache[47] || (_cache[47] = _createElementVNode("span", { class: "text-xs font-semibold text-gray-400 uppercase tracking-wider" }, "Bank Name", -1)),
                    _createElementVNode("span", _hoisted_72, _toDisplayString(agentProfileDetails.value.bank_name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_73, [
                    _cache[48] || (_cache[48] = _createElementVNode("span", { class: "text-xs font-semibold text-gray-400 uppercase tracking-wider" }, "Account Title", -1)),
                    _createElementVNode("span", _hoisted_74, _toDisplayString(agentProfileDetails.value.bank_account_name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_75, [
                    _cache[49] || (_cache[49] = _createElementVNode("span", { class: "text-xs font-semibold text-gray-400 uppercase tracking-wider" }, "Account / IBAN", -1)),
                    _createElementVNode("span", _hoisted_76, _toDisplayString(agentProfileDetails.value.bank_account_number), 1)
                  ]),
                  _createElementVNode("div", _hoisted_77, [
                    _cache[50] || (_cache[50] = _createElementVNode("span", { class: "text-xs font-semibold text-gray-400 uppercase tracking-wider" }, "Bank Country", -1)),
                    _createElementVNode("span", _hoisted_78, _toDisplayString(agentProfileDetails.value.country || '-'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_79, [
                  _cache[52] || (_cache[52] = _createElementVNode("label", {
                    for: "withdraw-points",
                    class: "uppercase text-xs font-extrabold text-gray-400 tracking-wider"
                  }, "Points to Withdraw *", -1)),
                  _createElementVNode("div", _hoisted_80, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((pointsToWithdraw).value = $event)),
                      type: "number",
                      id: "withdraw-points",
                      max: loyaltyData.value.points_earned,
                      placeholder: "Enter points count",
                      class: "w-full bg-transparent outline-none p-3.5 font-bold text-gray-800 text-base"
                    }, null, 8, _hoisted_81), [
                      [_vModelText, pointsToWithdraw.value]
                    ]),
                    _createElementVNode("span", _hoisted_82, " $" + _toDisplayString((Number(pointsToWithdraw.value || 0) * (Number(loyaltyData.value.redeem_rate) || 0.1)).toFixed(2)) + " USD ", 1)
                  ]),
                  (pointsError.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_83, _toDisplayString(pointsError.value), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", _hoisted_84, [
                    _cache[51] || (_cache[51] = _createTextVNode("Available loyalty points balance: ")),
                    _createElementVNode("strong", _hoisted_85, _toDisplayString(loyaltyData.value.points_earned), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_86, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: handleModalClose,
                    class: "px-5 py-2.5 bg-gray-100 hover:bg-gray-200 rounded-xl text-xs font-bold text-gray-600 uppercase transition-all"
                  }, "Cancel"),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: handleModalSubmit,
                    disabled: isBusy.value,
                    class: "px-5 py-2.5 bg-theme-active hover:bg-theme-active/95 text-white rounded-xl text-xs font-bold uppercase transition-all flex items-center gap-1.5 shadow-md disabled:opacity-50"
                  }, [
                    (isBusy.value)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_88, _cache[53] || (_cache[53] = [
                          _createElementVNode("circle", {
                            class: "opacity-25",
                            cx: "12",
                            cy: "12",
                            r: "10",
                            stroke: "currentColor",
                            "stroke-width": "4"
                          }, null, -1),
                          _createElementVNode("path", {
                            class: "opacity-75",
                            fill: "currentColor",
                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          }, null, -1)
                        ])))
                      : _createCommentVNode("", true),
                    _cache[54] || (_cache[54] = _createTextVNode(" Confirm Payout "))
                  ], 8, _hoisted_87)
                ]),
                (loyaltyRedeemForm.value.error)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_89, _toDisplayString(loyaltyRedeemForm.value.error), 1))
                  : _createCommentVNode("", true)
              ]))
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(Loader, { show: isLoading.value }, null, 8, ["show"])
  ], 64))
}
}

})